import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function NewsIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 70 70"
        {...props}
      >
        <path d="M51.4 17.7c.6-.1 1-.7.9-1.3s-.7-1-1.3-.9h-.1l-29.7 7.9c-2.1.6-3.7 2.4-4 4.5 0 .2-.1.5-.1.7v17.6c0 2.4 2 4.4 4.4 4.4h26.4c2.4 0 4.4-2 4.4-4.4V28.6c0-2.4-2-4.4-4.4-4.4H26.6zM19.2 28.8v-.4c.2-1.1 1.1-1.8 2.2-1.8h26.4c1.2 0 2.2 1 2.2 2.2v17.6c0 1.2-1 2.2-2.2 2.2H21.4c-1.2 0-2.2-1-2.2-2.2zm4.4 3.2c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h6.6c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1zm-1.1 4.4c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h8.8c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1zm1.1 4.4c-.6 0-1.1.5-1.1 1.1S23 43 23.6 43h6.6c.6 0 1.1-.5 1.1-1.1s-.5-1.1-1.1-1.1zm17.6 1.1c-2.4 0-4.4-2-4.4-4.4s2-4.4 4.4-4.4 4.4 2 4.4 4.4c0 2.5-2 4.4-4.4 4.4m-6.6-4.4c0 3.6 3 6.6 6.6 6.6s6.6-3 6.6-6.6-3-6.6-6.6-6.6-6.6 3-6.6 6.6" />
      </svg>
    </Icon>
  )
}
export default NewsIcon
